import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import { WORK_GROUPS } from '../../../utilities/constants';
import { getErrorValidateWithId } from '../../../utilities/works';
import { Dropdown } from '../../dropdowns/portal';

const GroupsTemplate = ({
  grid,
  context,
  msgValidate,
  handlePushParam,
  column,
}) => {
  const { isAbortedOrApproved } = context.item;
  const [data, setData] = useState('');
  useEffect(() => {
    setData(context.item.groups || '');
  }, [context.item.groups]);

  const handleOnChange = data => {
    if (isAbortedOrApproved) {
      return;
    }
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem['groups'] = data.id;
    if (!v.currentItem['is_data_changed']['groups']) {
      v.currentItem['is_data_changed']['groups'] = true;
    }
    v.commitEdit();
    handlePushParam(context.item);
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, 'groups');
  };

  const getGroup = () => {
    return WORK_GROUPS.map(item => ({
      id: item,
      name: item,
    }));
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(context, `item.is_data_changed.groups`)}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <Dropdown
        handleOnChange={handleOnChange}
        options={getGroup()}
        fieldName='name'
        fieldValue='id'
        name={data}
        value={data}
      >
        <Dropdown.Select readOnly={isAbortedOrApproved} />
        <Dropdown.List>
          <Dropdown.RadioItems />
        </Dropdown.List>
      </Dropdown>
    </CellContent>
  );
};

export default GroupsTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/GroupsTemplate.jsx